var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "div",
        { staticClass: "editor-container" },
        [
          _c("ckeditor", {
            attrs: { editor: _vm.editor, config: _vm.editorConfig },
            on: { ready: _vm.onReady },
            model: {
              value: _vm.editorData,
              callback: function ($$v) {
                _vm.editorData = $$v
              },
              expression: "editorData",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "BoxWrap",
        { attrs: { title: _vm.$t("sfe.noticeContent.BoxWrap.manage") } },
        [
          _c(
            "div",
            { attrs: { slot: "header-right" }, slot: "header-right" },
            [
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.back } },
                [_vm._v(_vm._s(_vm.$t("sfe.noticeContent.BoxWrap.cancel")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.preview },
                },
                [_vm._v(_vm._s(_vm.$t("sfe.noticeContent.BoxWrap.preview")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.create },
                },
                [_vm._v(_vm._s(_vm.$t("common.save")))]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "action-container" }),
        ]
      ),
      _vm._v(" "),
      _vm.dialogVisible
        ? _c("PreviewBox", {
            attrs: {
              "is-show": _vm.dialogVisible,
              data: _vm.editorData,
              "has-water-mark": _vm.hasWaterMark,
            },
            on: {
              "update:isShow": function ($event) {
                _vm.dialogVisible = $event
              },
              "update:is-show": function ($event) {
                _vm.dialogVisible = $event
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("input", {
        ref: "uploadVideoFileInput",
        staticClass: "is-hide",
        attrs: { type: "file", accept: ".mp4, .MP4" },
        on: { change: _vm.uploadVideoFileChange },
      }),
      _vm._v(" "),
      _c("input", {
        ref: "uploadFileInput",
        staticClass: "is-hide",
        attrs: { type: "file", accept: _vm.uploadFileType },
        on: { change: _vm.uploadFileChange },
      }),
      _vm._v(" "),
      _vm.isLoading
        ? _c(
            "div",
            { staticClass: "editor-loading" },
            [
              _c("vue-simple-spinner", {
                attrs: { size: "medium", "line-fg-color": "#004EA8" },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }